module.exports = __webpack_public_path__ + "img/lora.17670e95.jpg";